<template>
  <div class="BGProductionRecord">
      <!-- 蒙版（无数据时提示） -->
      <div v-if="showMask" class="nodataMask"><p>{{$t('DetailedStepReport.NoData')}}</p></div>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;background:#fff">
            <div class="mainWrao" >
              <div class="recordTitle" v-if="false">
                <h1>{{$t('leftNav.navTen')}}</h1>
                <div class="machineSeach">
                  <label style="margin-right:10px;font-size:12px;">{{$t('Production.labelTitle')}}</label>
                  <el-cascader
                    class="idStyle"
                    @change="getShiftTime()"
                    :placeholder="$t('Production.placehoder1')"
                    
                    expand-trigger="hover"
                    :options="options"
                    filterable
                    v-model="machineID">
                  </el-cascader>
                </div>
              </div>
              
                <!-- 柱状图1 -->
                <div class="barChart">
                  <!-- 柱状图 -->
                  <div id="chartWrap" style="width:100%">
                    <div v-if="machineTitle !== ''" style="padding-top:20px;">
                      <div v-show="$store.state.lang===0" class="chartTitle">{{'Green Tire Count of ' + machineTitle}}</div>
                      <div v-show="$store.state.lang===1" class="chartTitle">{{machineTitle + ' 的生胎数量'}}</div>
                      <p>{{twoShiftArr[0]}} ~ {{twoShiftArr[1]}}</p>
                    </div>
                    <div id="myChart" style="height: calc(100% - 100px); margin:0 auto;"></div>
                  </div>
                </div>
              
            </div>
        </el-scrollbar>
  </div>
</template>

<script>

export default {
  name: 'ProductionRecord',
  data () {
    return {
      resizeTimer: null,
     
      barChart: null,
      barChart2: null,
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID:'',
      // 选项
      radio: 1,
      radio2: 1,
      // 选择时间
      datePicker: null,
      datePicker2: null,
      // 显示隐藏echart
      // 禁用日期
      datedis: true,
      datedis2: true,
      machineTitle: '',
      machineTitle2: '',
      titleStartTime: '',
      titleEndTime: '',
      titleStartTime2: '',
      titleEndTime2: '',
      timeArr: [],
      numArr: [],
      workTimeArr: [],
      chart2_timeArr: [],
      chart2_numArr: [],
      chart2_workTimeArr: [],
      // 散点图数据
      pointPosition:[],
      pointPosition2:[],
    
      // 显示那个下拉框
      showSelect: 'a',
      // 选择的间隔时间
      selectValue1: '2',
      chart2selectValue1: '2',
      // X轴坐标
      selectValue2: '2',
      chart2selectValue2: '2',
      selectoptions1: [{
        value: '1',
        label: '1'+ this.$t('Production.hourTitle')
      }, {
        value: '2',
        label: '2'+ this.$t('Production.hoursTitle')
      }, {
        value: '12',
        label: '12'+ this.$t('Production.hoursTitle')
      }, {
        value: '24',
        label: '24'+ this.$t('Production.hoursTitle')
      }, {
        value: '1S',
        label: '1'+ this.$t('Production.shiftTitle')
      }],
      selectoptions2: [{
        value: '1',
        label: 'XX:00'
      }, {
        value: '2',
        label: 'XX:30',
      }],
      // 选择器逻辑
      twoShiftArr: null,
      threeShiftArr: null,
      timer: '',
      showMask:true
    }
  },
  mounted() {
    this.getId() 
    this.$store.commit('authority' , this.$route.path)
  },
  destroyed() {
    // clearInterval(this.resizeTimer)
    clearInterval(this.timer)
  },
  methods: {
    // 获取账号所属id
    getId(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.machineID = [res.data.machine.factoryId,res.data.machine.id]
          _this.getShiftTime()
          _this.timing()
        }
      })
    },
    //定时刷新数据
    timing(){
      let _this = this
      this.timer=setInterval(function(){
        _this.getShiftTime()
      },30000)
    },
    // 获取最近2班组，三班组时间
    getShiftTime(){
      let _this = this
      function format(st){
        var time = new Date(st);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y+'-'+checkTime(m)+'-'+checkTime(d)+' '+checkTime(h)+':'+checkTime(mm)+':'+checkTime(s);
      }
      function checkTime(i){
        if (i<10) {
          i="0" + i
        }
        return i
      }
      this.axios({
        method: 'get',
        url: '/url/selectLastShiftTime',
        params:{
          machineId: _this.machineID[1]
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          let twoShiftArr = [format(res.data.two.shiftStartTime), format(res.data.two.shiftEndTime)]
          let threeShiftArr = [format(res.data.three.shiftStartTime), format(res.data.three.shiftEndTime)]
          _this.twoShiftArr = twoShiftArr
          _this.threeShiftArr = threeShiftArr
          _this.getData()
        }else{
          _this.$message.error(res.data.msg);
        }
      })
    },
    
    // 获取数据s
    getData(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getProductionRecordData',
        params:{
          factoryId: _this.machineID[0],
          machineId: _this.machineID[1],
          codes: _this.radio,
          startTime: _this.twoShiftArr[0],
          endTime: _this.twoShiftArr[1],
          language: _this.$store.state.lang,
          hours: _this.selectValue1,
          Xtime: _this.selectValue2,
        }
      }).then(function(res){
        if ( res.data.success === 'true') {
          _this.timeArr = []
          _this.numArr = []
          _this.workTimeArr = []
          _this.pointPosition = []
          for (const item of res.data.info) {                       
            _this.timeArr.push(item.hours + '['+ item.shiftName +']')
            _this.numArr.push(item.num)
          }
          for (const pinitItem of res.data.scatterPointList) {
            let positipon = [pinitItem.timeStamp, pinitItem.cycleTime]
            _this.pointPosition.push(positipon)
          }
          _this.machineTitle = res.data.machineInfo.nameEn
          
          if (_this.datePicker !== null && _this.datePicker !== '') {
            _this.titleStartTime =  _this.datePicker[0]
            _this.titleEndTime =  _this.datePicker[1]
          }
          _this.initChart()
          _this.showMask =false
        } else {
          _this.showMask =true
        }
        

      })
    },
    // 柱形图初始化
    initChart(){
      let _this = this
      _this.barChart = this.$echarts.init(document.getElementById('myChart'))
      _this.barChart.setOption({
        color: ['#3398DB'],
        tooltip : {
          trigger: 'item',
          formatter: function(params){
            let res = params.name
            function format(st){
              var time = new Date(st);
              var y = time.getFullYear();
              var m = time.getMonth()+1;
              var d = time.getDate();
              var h = time.getHours();
              var mm = time.getMinutes();
              var s = time.getSeconds();
              return y+'-'+checkTime(m)+'-'+checkTime(d)+' '+checkTime(h)+':'+checkTime(mm)+':'+checkTime(s);
            }
            function checkTime(i){
              if (i<10) {
                i="0" + i
              }
              return i
            }
            if (params.componentSubType==='bar') {
              res = res + `<br/> ${params.marker} ${params.seriesName} : ${params.data} `
            } else {
              res = `${params.marker} ${params.seriesName} : ${params.data[1]} " <br/> ${params.marker} ${_this.$t('Production.tips')} : ${format(params.data[0])}`
            }
            
            return res
          },
          axisPointer : {
            type : 'shadow'
          }
        },
        // dataZoom: [{
        //     type: 'slider',
        //     xAxisIndex: [0,1],
        //     filterMode: 'weakFilter',
        //     height: 20,
        //     width: '90%',
        //     bottom: 0,
        //     start: 0,
        //     end: 100,
        //     handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        //     handleSize: '80%',
        //     showDetail: false
        // },{
        //     type: 'inside',
        //     id: 'insideX',
        //     xAxisIndex: [0,1],
        //     filterMode: 'weakFilter',
        //     start: 0,
        //     end: 100,
        //     zoomOnMouseWheel: true,
        //     moveOnMouseMove: true
        // }],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis : [
          {
            type : 'category',
            data : _this.timeArr,
            axisTick: {
                alignWithLabel: true
            }
          },
          {
            type : 'time',
            position: 'top',
            axisTick: {
                alignWithLabel: true
            }
          }
        ],
        yAxis : [
          {
            type : 'value',
            name : _this.$t('Production.Ylabel'),
            nameGap: 35,
            interval: 10,
            position: 'left'
          },
          {
            type : 'value',
            name : _this.$t('Production.Ylabel2'),
            nameGap: 35,
            position: 'right'
          }
        ],
        series : [
          {
            name: _this.$t('Production.placehoderLabel'),
            type:'bar',
            animation: false,
            label: {
                normal: {
                    show: true,
                    position: 'insideTop',
                    color: '#000'
                }
            },
            data: _this.numArr
          },
          {
            name:_this.$t('Production.Ylabel2'),
            type:'scatter',
            animation: false,
            xAxisIndex:1,
            yAxisIndex: 1,
            symbolSize: 8,
            itemStyle: {
              color:'red'
            },
            data: _this.pointPosition
          }
        ]




      })

      // this.resizeTimer = setInterval(function(){
      //   _this.barChart.resize()
      // },1000)
    },
  
  }
}
</script>
<style scoped>
.BGProductionRecord{
  height: 100%;
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
  
}
.seach button{
  float: right;
}
#chartWrap{
  height: 100%;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.dialog-title{
  font-size: 20px;
}
.axis{
  font-weight: bold;
  position: relative;
}
.axis:after{
  content: '';
  position: absolute;
  background:  rgba(229, 229, 229);
  height: 1px;
  width: 435px;
  top: 10px;
  left: 55px;
}
.dialogSelect{
  width: 390px;
  margin: 10px auto 0;
}
.dialogSelect label{
  display: inline-block;
  width: 160px;
}
.dialog-footer button{
  width: 90px;
}
.radioWrap{
  margin-right: 80px;
}
.recordTitle .machineSeach{
  float: right;
}
.barWrap{
  display: flex;
  min-height: 835px;
}
.barChart{
  border-radius: 2px;
  height: 100%;
  background-color: #fff!important;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.5);
}
#chartWrap p{
  text-align: center;
  color: rgba(166, 166, 166, 1);
  font-size: 16px;
  margin: 5px 0;
}
.interval{
  margin: 0 10px;
  font-size: 14px;
}
.el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
  width: 380px;
}
.el-scrollbar__view{
  height: 100%;
}
.nodataMask{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items:center
}
.nodataMask p {
  font-size: 5rem;
  color: #fff;

}
</style>

